module.exports = __webpack_public_path__ + "img/swap-mobile.ed4deb20.svg";